<arm-layout [summaryTitle]="'USERS GROUPS SUMMARY'">
    <div header>
        <div class="search-container">
            <client-filter (onFilter)="onFilter($event)"></client-filter>
        </div>

        <div class="action-buttons">
            <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                            (editClick)="editItem()" [disableEdit]="isUnauthorized || !isSingleSelection()"
                            (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !isSingleSelection()"
                            (refreshClick)="refresh()"></arm-action-bar>

            <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="exportToCSV()" [disabled]="isUnauthorized || !isSingleSelection()" mat-menu-item>
                    <span>Export Users</span>
                </button>

                <button (click)="openColumnsConfiguration()" mat-menu-item>
                    <span>Table columns</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div summary>
        <user-groups-summary [selection]="this.selection"></user-groups-summary>
    </div>

    <div main>
        <arm-table [displayedColumns]="displayedColumns" [data]="data" [filter]="filter"
                   (onSelection)="onSelection($event)" [isClientSide]="true"
                   [isMultipleSelection]="false"></arm-table>
    </div>
</arm-layout>
